import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PageTitle from '../../components/PageTitle';
import Header from '../../components/Header';
import './styles.css';
import SubscriptionModule from '../../components/SubscriptionModule';
import conferenceSvg from './conference.svg';
import calendarSvg from './calendar-4.svg';
import settingsSvg from './settings-window.svg';
import FeatureEnabled from '../../components/FeatureEnabled';
import FeatureDisabled from '../../components/FeatureDisabled';
import { COMMUNITY_SERVERLESS, DISABLE_LEGACY_COMMUNITY } from '../Authorization/constants';
import { withCommunityProfileIdQuery } from '../../utils/community';
import { withEnabledFeatures } from '../../utils/features';

function getUserFirstNameFromViewer(viewer) {
  return get(viewer, 'idToken.given_name') || get(viewer, 'idToken.name');
}

const SubscriptionsPage = (props) => {
  const { current } = props;
  const { viewer } = current;
  const isImpersonating = get(viewer, 'idToken.impersonator');
  const isNaviance = get(viewer, 'isNaviance');

  const isServerlessCommunityOn = get(props, 'enabledFeatures', []).includes(COMMUNITY_SERVERLESS);
  const communityProfileId = get(props, 'communityProfile.viewer.profile.communityId', '');
  const communityIdMatchesUUID = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/.test(communityProfileId);
  const isCommunityProfileServerless = !communityProfileId || communityIdMatchesUUID;
  const canAccessLegacyCommunity = !isServerlessCommunityOn || !isCommunityProfileServerless;

  return (
    <div styleName="main">
      <PageTitle title="Home" />
      <div styleName="content">
        <Header as="h1" size="huge" data-cy="homepage-welcome-heading" styleName="page-header">Welcome, {getUserFirstNameFromViewer(viewer)}</Header>
        <div styleName="modules-wrapper">
          {
            !isNaviance && (
              <FeatureEnabled allOf={[COMMUNITY_SERVERLESS]}>
                <SubscriptionModule
                  color="blue"
                  category="&nbsp;"
                  title="Counselor Community"
                  description="Find college staff, access college profiles, and export contact information."
                  buttonLabel="Explore"
                  image={conferenceSvg}
                  link="/counselorcommunity/"
                />
              </FeatureEnabled>
            )
          }
          {!!canAccessLegacyCommunity && (
            <FeatureDisabled anyOf={[DISABLE_LEGACY_COMMUNITY]}>
              <SubscriptionModule
                color="blue"
                category="&nbsp;"
                title="Counselor Community"
                description={'Connect and interact with admissions reps, \
                search and explore college profiles, and collaborate \
                with the broader community.'}
                buttonLabel="Participate"
                image={conferenceSvg}
                link="/community/"
              />
            </FeatureDisabled>
          )}
          <SubscriptionModule
            color="darkcyan"
            category="&nbsp;"
            title="RepVisits"
            description="Setup your school's visits availability, publish college fairs, and manage appointment requests."
            image={calendarSvg}
            buttonLabel="Schedule"
            link="/rep-visits/calendar"
          />
          {!isNaviance && !isImpersonating && (
            <SubscriptionModule
              color="grey"
              category="&nbsp;"
              title="Your settings"
              image={settingsSvg}
              description="Update your account settings."
              buttonLabel="Configure"
              link="/settings/change-profile"
            />
          )}
        </div>
      </div>
    </div>
  );
};

SubscriptionsPage.propTypes = {
  current: PropTypes.shape({
    viewer: PropTypes.shape({
      isNaviance: PropTypes.bool,
      idToken: PropTypes.shape({
        given_name: PropTypes.string,
        name: PropTypes.string,
        impersonator: PropTypes.string,
      }),
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  current: state.current,
});

export default withCommunityProfileIdQuery(withEnabledFeatures(connect(mapStateToProps)(SubscriptionsPage)));
